<template>
  <div>
    <confirm-third-party-modal :show="true" @confirm="handleProfileConfirmation" @cancel="handleCancel" />
  </div>
</template>

<script>
import ConfirmThirdPartyModal from './ConfirmThirdPartyModal.vue'

export default {
  components: {
    ConfirmThirdPartyModal,
  },
  data() {
    return {
      showProfileConfirm: false,
    }
  },
  mounted() {
    if (this.$route.query.next?.length === 0) {
      this.$router.push({
        name: 'Home',
      })
    }
  },
  methods: {
    handleProfileConfirmation() {
      window.location.href = this.$route.query.next
    },
    handleCancel() {
      // back to the previous page
      window.history.back()
    },
  },
}
</script>
